import React from 'react';
import { Link } from 'react-router-dom';
import { isEnglish } from '../i18n/locale';
import { JIKEYIXIA } from '../data/jikeyixia';
import LanguageControl from '../i18n/LanguageControl';
import usePageMetadata from '../hooks/usePageMetadata';
import peaceTechIcon from '../assets/peace-tech-logo.png';
import jikeyixiaIcon from '../assets/jikeyixia-icon.svg';
import passIcon from '../assets/pass-icon.png';
import noiseIcon from '../assets/noise-icon.png';
import ccremoteIcon from '../assets/ccremote-icon.png';
import nextholiIcon from '../assets/nextholi-icon.png';
import compresstoolsIcon from '../assets/compresstools-icon.png';
import quoteCamIcon from '../assets/quotecam-icon.png';
import tuttiHelperIcon from '../assets/tutti-helper-icon.png';
import '../styles/privacy-index.css';

const copy = isEnglish ? {
  title: 'Privacy Policies',
  description: 'Find the privacy policy for each PeaceTech app.',
  section: 'Our Apps',
  intro: 'Choose an app to read its privacy policy.',
  policy: 'Read privacy policy',
  back: '← Back to Home',
} : {
  title: '隐私政策',
  description: '查看 PeaceTech 各款应用的隐私政策。',
  section: '我们的应用',
  intro: '选择一款应用，查看对应的隐私政策。',
  policy: '查看隐私政策',
  back: '← 返回首页',
};

const apps = [
  { name: isEnglish ? 'Tutti Activity Helper' : 'Tutti 活动助手', icon: tuttiHelperIcon, path: '/tutti-helper/privacy' },
  { name: 'ZipWithPassword', icon: passIcon, path: '/zipwithpassword/privacy' },
  { name: 'Retro Noise', icon: noiseIcon, path: '/retronoise/privacy' },
  { name: 'CC Remote', icon: ccremoteIcon, path: '/ccremote/privacy' },
  { name: 'NextHoli', icon: nextholiIcon, path: '/nextholi/privacy' },
  { name: 'Compress Tools', icon: compresstoolsIcon, path: '/compresstools/privacy' },
  { name: 'QuoteCam', icon: quoteCamIcon, path: '/quotecam/privacy' },
  { name: isEnglish ? JIKEYIXIA.name.en : JIKEYIXIA.name.zh, icon: jikeyixiaIcon, path: '/jikeyixia/privacy' },
];

export default function PrivacyIndex() {
  usePageMetadata(`${copy.title} · PeaceTech`, copy.description, '/privacy');

  return (
    <div className="privacy-container privacy-index">
      <header className="privacy-header">
        <div className="app-info">
          <div className="app-icon"><img src={peaceTechIcon} alt="" /></div>
          <div className="app-details">
            <h1>{copy.title}</h1>
            <p>PeaceTech</p>
          </div>
        </div>
        <div className="privacy-index-actions">
          <LanguageControl />
          <Link to="/" className="back-link">{copy.back}</Link>
        </div>
      </header>

      <main className="privacy-content">
        <section className="privacy-section" aria-labelledby="privacy-index-apps">
          <h2 id="privacy-index-apps">{copy.section}</h2>
          <p>{copy.intro}</p>
          <ul className="privacy-index-list">
            {apps.map(app => (
              <li key={app.path}>
                <Link to={app.path} className="privacy-index-app">
                  <img src={app.icon} alt="" width="48" height="48" />
                  <span className="privacy-index-app-copy">
                    <strong>{app.name}</strong>
                    <span>{copy.policy}</span>
                  </span>
                  <span className="privacy-index-arrow" aria-hidden="true">→</span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      </main>
    </div>
  );
}
